/* Pure cart rules. Reuse on the server; browser execution is not checkout protection. */
(function (root) {
  'use strict';
  const count = value => Number.isSafeInteger(Number(value)) && Number(value) > 0 ? Number(value) : 0;
  function groupCart(items, eligibleIds, giftVariantIds) {
    const eligible = new Set(eligibleIds.map(String));
    const gifts = new Set(giftVariantIds.map(String));
    const groups = new Map();
    for (const item of items) {
      const id = String(item.product_id);
      if (!eligible.has(id) || gifts.has(String(item.variant_id)) || item.selling_plan_allocation || !count(item.quantity)) continue;
      if (!groups.has(id)) groups.set(id, { productId: id, quantity: 0, lines: [] });
      const group = groups.get(id);
      group.quantity += count(item.quantity);
      group.lines.push(item);
    }
    return [...groups.values()];
  }
  function planCart(items, eligibleIds, giftVariantIds) {
    if (giftVariantIds.length !== 2 || new Set(giftVariantIds.map(String)).size !== 2) throw new Error('Two distinct gift variants are required');
    const groups = groupCart(items, eligibleIds, giftVariantIds);
    const expected = new Map();
    const quantity = groups.reduce((sum, group) => sum + group.quantity, 0);
    const giftCount = Math.min(2, Math.max(0, quantity - 1));
    for (let slot = 1; slot <= giftCount; slot++) {
      expected.set(`cart:${slot}`, { id: Number(giftVariantIds[slot - 1]), quantity: 1,
        properties: { _mfvg_parent: 'cart', _mfvg_slot: String(slot), _mfvg_campaign: 'surprise-v2' } });
    }
    const updates = {};
    const giftIds = new Set(giftVariantIds.map(String));
    for (const item of items) {
      // Recognize gifts by trusted variant IDs, never by editable client properties alone.
      if (!giftIds.has(String(item.variant_id))) continue;
      const p = item.properties || {};
      const key = `${p._mfvg_parent}:${p._mfvg_slot}`;
      const desired = expected.get(key);
      if (!desired || String(desired.id) !== String(item.variant_id) || p._mfvg_campaign !== 'surprise-v2') updates[item.key] = 0;
      else {
        if (count(item.quantity) !== 1) updates[item.key] = 1;
        expected.delete(key);
      }
    }
    return { groups, quantity, giftCount, updates, additions: [...expected.values()] };
  }
  function validateCart(items, eligibleIds, giftVariantIds) {
    const plan = planCart(items, eligibleIds, giftVariantIds);
    // This helper reports invalid gift lines; it is not a server-side checkout validator.
    return Object.keys(plan.updates).length === 0;
  }
  async function reconcile(adapter, eligibleIds, giftVariantIds) {
    // Browser reconciliation is complemented by the merchant's manual fulfillment check.
    let cart = await adapter.read();
    let plan = planCart(cart.items, eligibleIds, giftVariantIds);
    if (Object.keys(plan.updates).length) cart = await adapter.update(plan.updates);
    plan = planCart(cart.items, eligibleIds, giftVariantIds);
    if (plan.additions.length) { await adapter.add(plan.additions); cart = await adapter.read(); }
    return cart;
  }
  const api = { groupCart, planCart, validateCart, reconcile };
  if (typeof module !== 'undefined' && module.exports) module.exports = api;
  else root.MFVGiftRules = api;
})(typeof globalThis !== 'undefined' ? globalThis : this);
